import React, { Suspense, lazy, ReactElement, ComponentType } from 'react'

import useDynamicScript from './useDynamicScript'

// @ts-ignore - allow js in this single file so as to not mess up webpack's processing
import loadComponent from './loadComponent'

export type RemoteType = {
  url: string
  scope: string
  module: string
}

const Remote = (props: {
  [x: string]: any
  remote: RemoteType
  Loading?: ComponentType | (() => ReactElement)
  Error?: ComponentType | (() => ReactElement)
}) => {
  const { remote, Loading, Error: ErrorComponent, ...rest } = props
  const { ready, failed } = useDynamicScript({
    url: remote && remote.url,
  })

  const LoadingComponent = Loading ? <Loading /> : null

  if (!remote) {
    return null
  }

  if (!ready) {
    return LoadingComponent
  }

  if (failed) {
    return ErrorComponent ? <ErrorComponent /> : null
  }

  const Component = lazy(loadComponent(remote.scope, remote.module))

  return (
    <Suspense fallback={LoadingComponent}>
      <Component {...rest} />
    </Suspense>
  )
}

export default Remote
